<mat-card (click)="cardClick()" *ngIf="card.display == 'Summary'"
    style="min-height: 115px; max-height: 115px; display: flex; flex-direction: row; cursor: pointer; padding: 0">

    <div [ngClass]="isDisabled()" style="display: flex; flex-direction: column; flex: .25;">
        <img *ngIf="!card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;"
            src="./assets/images/Card Attendance.png">
        <img *ngIf="card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;"
            src="./assets/images/Card Attendance disabled.png">
    </div>

    <div *ngIf="!card.disabled" class="robotoMedium" style="display: flex; flex-direction: column; flex: 1; font-size: 12pt; align-items: center;">
        <span style="padding: 5px; width: 100%;" translate>Today's Attendance</span>

        <div *ngIf="!dailyAttendance" style="display: flex; flex-direction: row; flex: 1; width: 100%">
            <div style="display: flex; flex-direction: column; flex: 1; align-items: center">
                <div class="robotoMedium" style="font-size: 28pt">
                    {{todaysTardyCount}}
                </div>
                <div style="display: flex; flex-direction: row; flex: 1; font-size: 10pt; font-weight: normal">
                    <span translate>Tardy</span>
                </div>
            </div>
            <div style="display: flex; flex-direction: column; flex: 1; align-items: center">
                <div class="robotoMedium" style="font-size: 28pt">
                    {{todaysAbsentCount}}
                </div>
                <div style="display: flex; flex-direction: row; flex: 1; font-size: 10pt; font-weight: normal">
                    <span translate>Absent</span>
                </div>
            </div>
        </div>

        <div *ngIf="dailyAttendance" style="display:flex; flex-direction:row; flex:1; width:100%">
            <div class="robotoMedium" style="font-size:28pt; width:100%;">
                <div style="display:flex; flex-direction:row; flex:1; font-weight:normal; width:100%; text-align:center;">
                    <span *ngIf="dailyAttendanceStatus == 'Absent'" style="width:100%; font-weight:bold;" translate>Absent</span>
                    <span *ngIf="dailyAttendanceStatus == 'Present'" style="width:100%; font-weight:bold;" translate>Present</span>
                    <span *ngIf="dailyAttendanceStatus == 'None'" style="width:100%; font-size:14px; padding-top:10px;" translate>No attendance data for today</span>
                </div>
            </div>
        </div>
    </div>

    <!--If Disabled-->
    <div *ngIf="card.disabled" style="display: flex; flex-direction: column; flex: 1">
        <div class="robotoMedium" style="display: flex; flex-direction: row; padding: 5px; flex: .25; font-size: 12pt; align-items: flex-start;">
            <span translate>Attendance</span>
        </div>
        <div class="robotoMedium"
            style="display: flex; flex-direction: row; flex: 2; justify-content: center; align-items: center; font-size: 14pt; color: red">
            <div>
                {{card.disabledMessage}}
            </div>
        </div>
    </div>
</mat-card>

<mat-card *ngIf="card.display == 'Detail'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Attendance</span>
            </div>
            <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; padding: 5px">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end">
                    <button mat-stroked-button class="mat-card-button" (click)="viewAllClick()">
                        <span translate>Go To Attendance</span>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="!card.disabled" style="display: flex; flex-direction: column; flex: 1">
            <div style="display: flex; flex-direction: column; flex: 1;">
                <div class="robotoMedium" style="display: flex; flex-direction: row; font-size: 12pt; margin-left: 10px; margin-top: 5px;">
                    <span translate>Today</span>
                </div>
                <div style="display: flex; flex-direction: row; justify-content: center; padding: 10px"
                    *ngIf="studentAttendance.length == 0">
                    <span translate>No tardies or absences today</span>
                </div>
            </div>
            <table *ngIf="studentAttendance.length > 0" mat-table [dataSource]="studentAttendance" style="width: 100%">

                <!-- Class Column -->
                <ng-container matColumnDef="Class">
                    <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Class</span></th>
                    <td mat-cell *matCellDef="let attendanceRecord" style="font-size: 10pt;"> {{attendanceRecord.Class}}</td>
                </ng-container>

                <!-- Meets Column -->
                <ng-container matColumnDef="Meets">
                    <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Meets</span></th>
                    <td mat-cell *matCellDef="let attendanceRecord" style="font-size: 10pt;" [innerHTML]="attendanceRecord.Meets"></td>
                </ng-container>

                <!-- Marked Column -->
                <ng-container matColumnDef="Marked">
                    <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Marked</span></th>
                    <td mat-cell *matCellDef="let attendanceRecord" style="font-size: 10pt;">
                        {{attendanceRecord.Marked}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div *ngIf="!v10" class="robotoMedium" style="display: flex; flex-direction: row; font-size: 12pt; margin-left: 10px; margin-top: 5px; margin-bottom: 5px;">
                <span translate>Year-To-Date</span>
            </div>
            <div *ngIf="!v10" style="display:flex; flex-direction: row; margin-left: 5px; padding: 5px">
                <div style="display: flex; flex-direction: column; flex: 1.5;padding-left: 5px">
                    <div style="display: flex; flex: .80; white-space: pre">
                        {{DaysPresent |number:'2.2-2'}} <span translate>of</span> {{TotalDays |number:'2.2-2'}} <span translate>Days</span>
                        ({{((DaysPresent/TotalDays)*100)|number:'2.2-2'}} %)
                    </div>
                    <div style="display: flex; flex: .80; white-space: pre">
                        {{HoursPresent |number:'2.2-2'}} <span translate>of</span> {{TotalHours |number:'2.2-2'}} <span translate>Hours</span>
                        ({{((HoursPresent/TotalHours)*100)|number:'2.2-2'}} %)
                    </div>

                </div>
            </div>

        </div>
        <!--If Disabled-->
        <div *ngIf="card.disabled" class="robotoMedium"
            style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
            <div style="padding: 50px;">
                {{card.disabledMessage}}
            </div>
        </div>
    </div>
</mat-card>
